export const INITIATIVE_VALUES = ['A','K','Q','J','10','9','8','7','6','5','4','3','2'];
